import { render, staticRenderFns } from "./WelcomeTitle.vue?vue&type=template&id=ee437208&scoped=true&"
import script from "./WelcomeTitle.vue?vue&type=script&lang=js&"
export * from "./WelcomeTitle.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeTitle.vue?vue&type=style&index=0&id=ee437208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee437208",
  null
  
)

export default component.exports